import { watch, useSlots, computed } from 'vue';
import { registerCssVariables, umountCssVariables } from '../style/theme-helper';
import { firstWordToLowerCase } from '../utils';
/**
 * 自动隐藏空菜单
 * @param menuList
 * @param nav
 */
export function useHideEmptyMenu(menuList, nav, isMobile) {
  var needHide = computed(function () {
    var _menuList$value;
    return ((_menuList$value = menuList.value) === null || _menuList$value === void 0 ? void 0 : _menuList$value.length) === 0 && nav.value === 'mix' || isMobile.value;
  });
  watch(needHide, function (val) {
    if (val) {
      registerCssVariables({
        'width-side': '0px',
        'width-side-collapsed': '0px'
      }, '.stepin-layout-theme');
    } else {
      umountCssVariables('.stepin-layout-theme');
    }
  }, {
    immediate: true
  });
}
/**
 * 获取 TabsView 组件的 slots
 */
export function useTabsViewSlots() {
  var slots = useSlots();
  var tabSlots = computed(function () {
    return Object.keys(slots).filter(function (slot) {
      return slot.startsWith('tab');
    }).map(function (k) {
      return {
        name: k,
        tabSlot: firstWordToLowerCase(k.replace('tab', ''))
      };
    });
  });
  return {
    slots: tabSlots
  };
}